/* eslint-disable no-console */
import axios from "axios";
import { getToken } from "store/auth";

import { env } from "../env.js";

// const urlPath = "https://api.domlivery.dominos.com.br";
// const dsForceOrigin = "https://admin.domlivery.dominos.com.br";

// const dsUrl = "https://api.homolog.teamsoft.com.br";
// const dsForceOrigin = "https://dominos.teamsoft.com.br";

// const urlPath = "https://developer.teamsoft.com.br";
// const dsForceOrigin = "https://developer.teamsoft.com.br";

const urlPath =
  env.NODE_ENV === "prod"
    ? env.API_PROD
    : env.NODE_ENV === "homolog"
    ? env.API_HOMOLOG
    : env.API_DEV;

const dsForceOrigin =
  env.NODE_ENV === "prod"
    ? env.ORIGIN_PROD
    : env.NODE_ENV === "homolog"
    ? env.ORIGIN_HOMOLOG
    : env.ORIGIN_DEV;

export const apiauth = () => {
  const token = getToken();

  return axios.create({
    baseURL: `${urlPath}/authenticator_api`,
    headers: {
      Authorization: `Bearer ${token}`,
      "force-origin": dsForceOrigin,
    },
  });
};

export const apicommercial = () => {
  const token = getToken();

  return axios.create({
    baseURL: `${urlPath}/commercial_api`,
    headers: {
      Authorization: `Bearer ${token}`,
      "force-origin": dsForceOrigin,
    },
  });
};

export const apicontrol = () => {
  const token = getToken();

  return axios.create({
    baseURL: `${urlPath}/control_api`,
    headers: {
      Authorization: `Bearer ${token}`,
      "force-origin": dsForceOrigin,
    },
  });
};
